"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MetaDataFilters = void 0;
exports.MetaDataFilters = [
    {
        field: 'metadata.createdAt',
        type: 'TIMESTAMP',
        alias: 'Created At',
        shortName: 'Created',
        allowedOperators: 'ALL',
        format: 'ISO',
        disabledOn: ['customer-portal'],
    },
    {
        field: 'metadata.lastUpdatedAt',
        type: 'TIMESTAMP',
        alias: 'Last Updated At',
        shortName: 'Last Updated',
        allowedOperators: 'ALL',
        format: 'ISO',
        disabledOn: ['customer-portal'],
    },
];
//# sourceMappingURL=meta-data.js.map